export default __webpack_public_path__ + "static/cashflow_202_1996_9-491490ca53aedde658d43c5c40e5864d.jpg";